import React, {useMemo} from 'react'
import {makeStyles, Table, TableBody, TableCell, TableHead, TableRow} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import OfferTableRow from "./OfferTableRow";
import {isDemandFinishing, isDemandFinished, isDemandOfferEvaluation} from "../../../../libs/getDemandStatus";

const useStyle = makeStyles(theme => ({
    root: {},
    table: {
        border: `solid 3px ${theme.palette.background.paper}`,
        "& .MuiTableCell-root": {
            padding: theme.spacing()
        }
    },
    lpColumn: theme.components.table.lpColumn,
    dateColumn: {
        ...theme.components.table.buttonColumn,
        width: theme.components.table.dateTimeColumn.width + theme.components.table.buttonColumn.width
    },
    buttonColumn: theme.components.table.buttonColumn,
    supplierColumn: {
        paddingRight: theme.spacing(2),
        "word-break": "break-all"
    },
    authorColumn: {
        width: 250
    },
    addressColumn: {
        width: 160,
        paddingRight: theme.spacing(2),
        whiteSpace: "pre-line"
    },
    statusColumn: {
        width: 200,
        paddingRight: theme.spacing(2)
    },
}));

function OfferTable(
    {
        demandId,
        currentRfxRound,
        offers,
        openEnvelopeEdit,
        demandHeader
    }) {
    const classes = useStyle();
    const collectionFinished = useMemo(()=> isDemandOfferEvaluation() || isDemandFinishing() || isDemandFinished(), []);

    return (
        <div className={classes.root}>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow className={classes.headRow}>
                        <TableCell className={classes.lpColumn}>{Tr("column_lp")}</TableCell>
                        <TableCell className={classes.supplierColumn}>{Tr("contractor")}</TableCell>
                        <TableCell className={classes.authorColumn}>{Tr("author")}</TableCell>
                        <TableCell className={classes.addressColumn}>{Tr("adres")}</TableCell>
                        <TableCell className={classes.statusColumn}>{Tr("status")}</TableCell>
                        <TableCell className={classes.dateColumn}>{Tr("date_of_receipt")}</TableCell>
                        <TableCell className={classes.buttonColumn}></TableCell>
                        {collectionFinished && <TableCell className={classes.buttonColumn}></TableCell>}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        offers.items.map((item, i) => <OfferTableRow
                            key={item.id}
                            demandId={demandId}
                            currentRfxRound={currentRfxRound}
                            offer={item}
                            index={i}
                            openEnvelopeEdit={openEnvelopeEdit}
                            collectionFinished={collectionFinished}
                            demandHeader={demandHeader}
                        />)
                    }
                </TableBody>
            </Table>
        </div>
    )
}

OfferTable.propTypes = {
    currentRfxRound: PropTypes.shape({
        id: PropTypes.number.isRequired,
        processId: PropTypes.number.isRequired,
        stageId: PropTypes.number.isRequired,
        offerCollectionEnded: PropTypes.bool.isRequired
    }).isRequired,
    offers: PropTypes.object.isRequired,
    openEnvelopeEdit: PropTypes.func.isRequired
}

export default OfferTable;
